// 配置API接口地址
//var root = 'https://cnodejs.org/api/v1'
var root = 'https://api.xiaohucloud.com'
import Vue from 'vue'
var exec = new Vue();
//console.log(url)
if(window.location.host.indexOf("prediy.") != -1) {
	root = 'https://preapi.xiaohucloud.com'
} else if(window.location.host.indexOf(".com") != -1) {
	root = 'https://api.xiaohucloud.com'
}
// 自定义判断元素类型JS
function toType(obj) {
	return({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}
// 参数过滤函数
function filterNull(o) {
	for(var key in o) {
		if(o[key] === null) {
			delete o[key]
		}
		if(toType(o[key]) === 'string') {
			o[key] = o[key].trim()
		} else if(toType(o[key]) === 'object') {
			o[key] = filterNull(o[key])
		} else if(toType(o[key]) === 'array') {
			o[key] = filterNull(o[key])
		}
	}
	return o
}

/*
  接口处理函数
  这个函数每个项目都是不一样的，我现在调整的是适用于
  https://cnodejs.org/api/v1 的接口，如果是其他接口
  需要根据接口的参数进行调整。参考说明文档地址：
  https://cnodejs.org/topic/5378720ed6e2d16149fa16bd
  主要是，不同的接口的成功标识和失败提示是不一致的。
      另外，不同的项目的处理方法也是不一致的，这里出错就是简单的alert
*/
function GetQueryString(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
	var r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
	var context = "";
	if(r != null)
		context = r[2];
	reg = null;
	r = null;
	return context == null || context == "" || context == "undefined" ? "" : context;
}

function apiAjax(method, async, url, params, success, failure) {
	if(params) {
		params = filterNull(params)
	}
	if(url.indexOf("http") != 0) {
		url = root + url;
	}
	let obj = $.extend({
		token:GetQueryString("token"),
		lang:GetQueryString("lang"),
		type:GetQueryString("type"),
		versionId:GetQueryString("type")==1?GetQueryString("pc_version_id"):GetQueryString("mobile_version_id"),
		version_id:GetQueryString("type")==1?GetQueryString("pc_version_id"):GetQueryString("mobile_version_id"),
		companyId:GetQueryString("company_id")
	}, params);
    //debugger
	$.ajax({
		type: method,
		url: url,
		data: obj,
		async: async,
		//crossDomain: true,
		//contentType: false,
		//processData: false,
		dataType: 'json',
		success: function(data) {
			if(data.code == 422) {
				//console.log("请重新登录")
				exec.$msg("请重新登录");
				setTimeout(function() {
					//location.href = "https://console.xiaohucloud.com/admin/login";
				}, 3000);
			} else {
				if(success && typeof success == "function") {
         
					success(data);
				}
			}

		},
		error: function(err) {
			console.log("error");
			exec.$msg("对不起,保存失败,请联系管理员");
			if(failure && typeof failure == "function") {
				failure(err);
			}
		}
	});
}

// 返回在vue模板中的调用接口
export default {
	get: function(url, async = true, params = {}, success, failure) {
		return apiAjax('GET', async, url, params, success, failure)
	},
	post: function(url, async = true, params = {}, success, failure) {
		return apiAjax('POST', async, url, params, success, failure)
	},
	put: function(url, async = true, params = {}, success, failure) {
		return apiAjax('PUT', async, url, params, success, failure)
	},
	delete: function(url, async = true, params = {}, success, failure) {
		return apiAjax('DELETE', async, url, params, success, failure)
	}
}



// WEBPACK FOOTER //
// ./src/api/$ajax.js